// extracted by css-extract-rspack-plugin
export default {"container":"_6d98004b","title":"_c397420c","divider":"_3ea599cd","regularFontBody":"_d2393bd5","smallFontBody":"_f89b87d0","viewMoreButton":"_bec2afa2"};